import React from 'react';
import i18n from '../../../i18';
import { AssociatedBlockComponent } from '../../../components/associated-block';
import { EmptyWalletTransparentBulkIcon } from '../../../icons-lib';
import { Box, Typography } from '@mui/material';
export default class DialogDetailsField extends React.Component {
    render() {
        const { field, value } = this.props;
        const primaryTitle = i18n.t(`columns.${field.primary}`);
        const secondaryTitle = i18n.t(`columns.${field.secondary}`);
        const primaryContent = value[field.primary];
        const secondaryContent = value[field.secondary];
        const translatedLabel = i18n.t(`columns.${field.label}Details`);
        const icons = {
            walletNumber: <EmptyWalletTransparentBulkIcon />,
        };
        return (
            <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle1">{translatedLabel}</Typography>
                <AssociatedBlockComponent
                    icon={icons[field.label]}
                    primaryTitle={primaryTitle}
                    secondaryTitle={secondaryTitle}
                    primaryContent={primaryContent}
                    secondaryContent={secondaryContent}
                    primaryContentColor={'highlighted'}
                />
            </Box>
        );
    }
}
